import { useEffect } from 'react';

// Backstop for the CSS opt-out in index.css: WebKit ignores `user-select: none` in some
// long-press paths and selects the row anyway. The menu opens before iOS commits the
// selection, so anything landing while it is open gets dropped as it appears.
export const useSuppressSelection = (isActive: boolean) => {
  useEffect(() => {
    if (!isActive) {
      return;
    }

    const clear = () => {
      const selection = document.getSelection();
      // guard against re-entering on the change our own clearing fires
      if (selection && !selection.isCollapsed) {
        selection.removeAllRanges();
      }
    };

    clear();
    document.addEventListener('selectionchange', clear);

    return () => document.removeEventListener('selectionchange', clear);
  }, [isActive]);
};
